import * as React from "react";

const AeroplaneIcone = (props) => (
  <svg
    viewBox="0 0 48 32"
    preserveAspectRatio="xMidYMid meet"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="m2.15 13.407.253-.084a1.554 1.554 0 0 1 1.319.162L7.65 15.96a3.254 3.254 0 0 0 2.613.384l10.55-2.937L14.58 2.695a.779.779 0 0 1 .445-1.136l.735-.223a3.88 3.88 0 0 1 3.45.607l11.8 8.767s3.615-.958 7.968-2.08c4.66-1.201 7.017-.247 7.435 1.206.418 1.454-.793 3.571-5.756 4.954-7.543 2.11-28.302 7.596-28.302 7.596a6.222 6.222 0 0 1-6.67-2.36l-3.918-5.422a.776.776 0 0 1 .385-1.197v0Z"
      stroke="#1758FE"
      //   fill="#1758FE"
      strokeWidth={1.583}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m21.546 19.911-3.227 9.761a.776.776 0 0 0 .907 1.012l.533-.118a4.666 4.666 0 0 0 2.62-1.649l8.27-11.366"
      stroke="#1758FE"
      //   fill="#1758FE"
      strokeWidth={1.583}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m14.828 17.294.139.472M36.729 11.39l.141.476M33.078 12.375l.138.472M29.427 13.36l.141.472M25.775 14.344l.142.472M18.476 16.31l.142.475M22.127 15.325l.139.476"
      stroke="#1758FE"
      strokeWidth={1.583}
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);

export default AeroplaneIcone;
